import { useSyncExternalStore } from 'react';
import ManagdPageLoader from './ManagdPageLoader';
import { hasPendingInformation, getOperationMessage, subscribeInformationLoading } from '../utils/dataLoading';
export default function LoadingPopup({ visible, message = 'Loading...' }) {
    const reading = useSyncExternalStore(subscribeInformationLoading, hasPendingInformation, () => false)
    const operation = useSyncExternalStore(subscribeInformationLoading, getOperationMessage, () => '')
    const explicitOperation = /sav|send|generat|download|upload|delet|creat|process|submit/i.test(message)
    return <ManagdPageLoader visible={visible && (!!operation || (!reading && explicitOperation))} message={/^loading/i.test(message) ? operation : message} />
}
